import React, { Component } from "react";
import Checkbox from "material-ui/Checkbox";
import { primaryColor, isVowel } from "../../../../utils/utility";
import { Typeahead } from "react-bootstrap-typeahead";
import uniq from "lodash/uniq";
import "./automake.css";
import Tooltip from "react-tooltip-lite";

// worker
import worker_script from "./worker";

const styles = {
  iconStyle: {
    fill: primaryColor(),
  },
};

class AutoMake extends Component {
  constructor(props) {
    super(props);
    this.myWorker = new Worker(worker_script);
    this.state = {
      ifShowStyle: false,
      activeBrandIndex: "",
      clickedMakeLabel: "",
      beSearchedMakeId: "",
      beSearchedModelId: "",
      ifAllModelSelected: false,
      make_active_arr: [], // store make label match model
    };
  }
  componentDidMount() {
    const autoMake = this.props.demoAttributes
      .filter(item => item.name === "Auto")[0]
      .attributes.filter(item => item.name === "Auto Make/Model")[0].values;

    // filter model for each brand
    const model = this.props.demoAttributes
      .filter(item => item.name === "Auto")[0]
      .attributes.filter(item => item.name === "Auto Model")[0].values;
    // .filter((item) => item.label.split(' - ')[0].toLowerCase() === this.state.clickedMakeLabel.toLowerCase())

    // check have model be selected
    let arr = [];
    model.forEach(item => {
      this.props.selected_segments.forEach(id => {
        if (item.id === id) {
          arr.push(item.label.split(" - ")[0]);
        }
      });
    });
    this.props.addMakeActive(uniq(arr));

    // filter the make from model list in arr array in index 0
    let model_filter = [];
    if (uniq(arr).length > 0) {
      model_filter = model.filter(
        item =>
          item.label.split(" - ")[0].toLowerCase() ===
          uniq(arr)[0].toLowerCase(),
      );
    }
    let make_index = [];
    let model_index = [];
    autoMake.forEach((item, index) => {
      this.props.selected_segments.forEach(makeId => {
        if (makeId === item.id) {
          make_index.push(index);
        }
      });
    });

    let makeObj = {
      id: "",
      label: "",
    };
    if (model_filter.length > 0) {
      autoMake.forEach((make, index) => {
        if (
          make.label.split(" - ")[0].toLowerCase() ===
          model_filter[0].label.split(" - ")[0].toLowerCase()
        ) {
          model_index.push(index);
          makeObj.id = make.id;
          makeObj.label = make.label;
        }
      });
    }

    // if make checkbox selected index lower
    let liHeight = this.refs.autoMakeList.clientHeight;
    if (make_index[0] < model_index[0]) {
      this.refs.makeUl.scrollTop = liHeight * make_index[0];
    } else if (make_index[0] > model_index[0]) {
      // if make have model and index lower
      this.refs.makeUl.scrollTop = liHeight * model_index[0];
      this.handleBrandClick(
        {
          target: {
            type: "text",
          },
        },
        make_index[0],
        makeObj.label,
        makeObj.id,
      );
    }
  }
  handleBrandClick(e, index, makeLabel, makeId) {
    // console.log(index)
    // console.log(makeLabel)
    // console.log(makeId)

    if (e.target.type !== "checkbox") {
      this.setState({
        ifShowStyle: true,
        activeBrandIndex: index,
        clickedMakeLabel: makeLabel,
        beSearchedMakeId: makeId,
      });
      if (this.props.selected_make.some(item => item.id === makeId)) {
        this.setState({
          ifAllModelSelected: true,
        });
      } else {
        this.setState({
          ifAllModelSelected: false,
        });
      }
      let model = this.props.demoAttributes
        .filter(item => item.name === "Auto")[0]
        .attributes.filter(item => item.name === "Auto Model")[0]
        .values.filter(
          item =>
            item.label.split(" - ")[0].toLowerCase() ===
            makeLabel.toLowerCase(),
        );

      if (this.props.selected_segments.length > 0 && model.length > 0) {
        let selected_model_position_index = [];
        let model_position_id = [];
        model.forEach((model, index) => {
          if (this.props.selected_segments.some(item => item === model.id)) {
            model_position_id.push(model.id);
            selected_model_position_index.push(index);
          }
        });
        window.setTimeout(() => {
          let liHeight = this.refs["modelList"].clientHeight;
          this.refs.modelUl.scrollTop =
            selected_model_position_index[0] * liHeight;
          this.setState({
            beSearchedModelId: model_position_id[0],
          });
        }, 300);
      }
    }
  }
  chooseSegmentValues(id, ifAdd) {
    let selected = this.props.selected_segments
      ? this.props.selected_segments
      : [];

    if (ifAdd) {
      selected.push(id);
    } else {
      let idx = selected ? selected.indexOf(id) : -1;
      if (idx >= 0) {
        selected.splice(idx, 1);
      }
    }
    this.props.selectSegment(selected);
  }
  // handle automake check
  handleBrandSelected(e, isInputChecked, makeObj) {
    this.props.selectMake(makeObj, isInputChecked);
    this.chooseSegmentValues(makeObj.id, isInputChecked);

    // const model = this.props.demoAttributes
    //   .filter((item) => item.name === 'AUTO/TRANSPORT')[0].attributes
    //   .filter((item) => item.name === 'Auto Model')[0].values
    //   .filter((item) => item.label.split(' - ')[0].toLowerCase() === makeObj.label.toLowerCase())
    if (isInputChecked) {
      this.setState({
        ifShowStyle: false,
        beSearchedMakeId: "",
      });
      // web worker
      this.myWorker.postMessage({
        demoAttributes: this.props.demoAttributes,
        makeObj,
        selected_segments: this.props.selected_segments,
      });
      this.myWorker.onmessage = e => {
        this.props.selectSegment(e.data);
      };
      // model.map((item) => {
      //   this.chooseSegmentValues(item.id, !isInputChecked)
      // })

      this.props.addMakeActive(
        this.props.make_active_arr.filter(
          item => item.toLowerCase() !== makeObj.label.toLowerCase(),
        ),
      );
    } else if (!isInputChecked) {
      this.setState({
        ifShowStyle: false,
      });
    }
  }
  /**
   * @param {Object} data the data of search
   * @param {string} listTarget the value of ref for li element
   * @param {string} parentTarget the value of ref for ul element
   * @param {string} searchId the state's property for make/model
   * @returns {null}
   */
  handleMakeOrModelChange(
    selectedItem,
    data,
    listTarget,
    parentTarget,
    searchId,
  ) {
    let liHeight = this.refs[listTarget].clientHeight;
    if (selectedItem.length > 0) {
      data.forEach((make, index) => {
        if (make.id === selectedItem[0].id) {
          // compute scrollTop
          this.refs[parentTarget].scrollTop = index * liHeight;
          if (searchId === "beSearchedMakeId") {
            this.setState({
              beSearchedMakeId: selectedItem[0].id,
            });
          }
          if (searchId === "beSearchedModelId") {
            this.setState({
              beSearchedModelId: selectedItem[0].id,
            });
          }
        }
      });
    }
  }

  handleModelSelected(e, isInputChecked, modelObj) {
    this.props.selectModel(modelObj, isInputChecked);
    this.chooseSegmentValues(modelObj.id, isInputChecked);
    this.setState({
      beSearchedModelId: "",
    });
    const autoParent = this.props.demoAttributes
      .filter(item => item.name === "Auto")[0]
      .attributes.filter(item => item.name === "Auto Model")[0].values;
    let arr = [];
    autoParent.forEach(item => {
      this.props.selected_segments.forEach(id => {
        if (item.id === id) {
          arr.push(item.label.split(" - ")[0]);
        }
      });
    });
    this.props.addMakeActive(uniq(arr));
  }
  render() {
    // filter automake from demoAttributes
    const autoMake = this.props.demoAttributes
      .filter(item => item.name === "Auto")[0]
      .attributes.filter(item => item.name === "Auto Make/Model")[0].values;
    const makeGranularity = this.props.demoAttributes
      .filter(item => item.name === "Auto")[0]
      .attributes.filter(item => item.name === "Auto Make/Model")[0]
      .granularity;
    const modelGranularity = this.props.demoAttributes
      .filter(item => item.name === "Auto")[0]
      .attributes.filter(item => item.name === "Auto Model")[0].granularity;
    // filter model for each brand
    const model = this.props.demoAttributes
      .filter(item => item.name === "Auto")[0]
      .attributes.filter(item => item.name === "Auto Model")[0]
      .values.filter(
        item =>
          item.label.split(" - ")[0].toLowerCase() ===
          this.state.clickedMakeLabel.toLowerCase(),
      );

    return (
      <div className="auto-make">
        <div className="row">
          <div className="col-xs-6 col-md-6 col-sm-6 col-lg-6">
            <div className="search clearfix">
              <div
                className="col-xs-11 col-md-11 col-sm-11 col-lg-11"
                style={{ padding: 0, marginTop: "-5px" }}
              >
                <span className="input-group" style={{ width: "100%" }}>
                  <Typeahead
                    labelKey="label"
                    multiple={false}
                    placeholder="Find an Auto Make"
                    options={autoMake}
                    onChange={selectedItem =>
                      this.handleMakeOrModelChange(
                        selectedItem,
                        autoMake,
                        "autoMakeList",
                        "makeUl",
                        "beSearchedMakeId",
                      )
                    }
                  />
                  <div
                    className="form-control-feedback"
                    style={{ width: "54px" }}
                  >
                    <span className="text-uppercase no-padding no-margin">
                      search
                    </span>
                  </div>
                </span>
              </div>
            </div>
            <ul className="brand-wrapper" ref="makeUl">
              {/*render states list*/}
              {autoMake.map((item, index) => (
                <li
                  key={item.id}
                  onClick={e =>
                    this.handleBrandClick(e, index, item.label, item.id)
                  }
                  ref="autoMakeList"
                  className={
                    item.id === this.state["beSearchedMakeId"] ? "active" : ""
                  }
                >
                  <Checkbox
                    onCheck={(e, isInputChecked) =>
                      this.handleBrandSelected(e, isInputChecked, item)
                    }
                    label={
                      <Tooltip
                        content={
                          <div
                            className="p-10 black-border"
                            style={{ background: "#FFF" }}
                          >
                            {makeGranularity}
                          </div>
                        }
                        direction="right"
                      >
                        {item.label}
                      </Tooltip>
                    }
                    iconStyle={styles.iconStyle}
                    inputStyle={{ width: "35px" }}
                    labelStyle={{
                      fontSize: "15.6px",
                      width: "auto",
                      padding: "0 10px",
                    }}
                    checked={this.props.selected_segments.some(
                      list => list === item.id,
                    )}
                  />
                  <span
                    className="text-teal-400"
                    style={{
                      position: "absolute",
                      top: "0",
                      right: "3.1em",
                      display: this.props.make_active_arr.some(
                        list => list.toLowerCase() === item.label.toLowerCase(),
                      )
                        ? "inline"
                        : "none",
                    }}
                  >
                    <i className="icon-checkmark4 " />
                  </span>

                  <small
                    style={{
                      display:
                        this.state.activeBrandIndex === index &&
                        this.state.ifShowStyle
                          ? "none"
                          : "inline",
                    }}
                  >
                    >
                  </small>
                </li>
              ))}
            </ul>
          </div>
          <div
            className="col-xs-6 col-md-6 col-sm-6 col-lg-6"
            style={{ display: this.state.ifShowStyle ? "block" : "none" }}
          >
            <div className="search clearfix">
              <div
                className="col-xs-12 col-md-12 col-sm-12 col-lg-12"
                style={{ padding: 0, marginTop: "-5px" }}
              >
                <span className="input-group" style={{ width: "100%" }}>
                  <Typeahead
                    labelKey="label"
                    multiple={false}
                    placeholder={`Find ${
                      isVowel(this.state.clickedMakeLabel) ? "an" : "a"
                    } ${this.state.clickedMakeLabel} Model`}
                    options={model}
                    onChange={selectedItem =>
                      this.handleMakeOrModelChange(
                        selectedItem,
                        model,
                        "modelList",
                        "modelUl",
                        "beSearchedModelId",
                      )
                    }
                  />
                  <div
                    className="form-control-feedback"
                    style={{ width: "54px" }}
                  >
                    <span className="text-uppercase no-padding no-margin">
                      search
                    </span>
                  </div>
                </span>
              </div>
            </div>
            <ul className="model-wrapper" ref="modelUl">
              {/*render states list*/}
              {model.map(item => (
                <li
                  key={item.id}
                  ref="modelList"
                  className={
                    item.id === this.state["beSearchedModelId"] ? "active" : ""
                  }
                >
                  <Checkbox
                    onCheck={(e, isInputChecked) =>
                      this.handleModelSelected(e, isInputChecked, item)
                    }
                    inputStyle={{ width: "35px" }}
                    label={
                      <Tooltip
                        content={
                          <div
                            className="p-10 black-border"
                            style={{ background: "#FFF" }}
                          >
                            {modelGranularity}
                          </div>
                        }
                        direction="right"
                      >
                        {item.label}
                      </Tooltip>
                    }
                    iconStyle={styles.iconStyle}
                    labelStyle={{ fontSize: "15.6px", width: "auto" }}
                    checked={
                      this.props.selected_segments.some(
                        model => model === item.id,
                      ) || this.state.ifAllModelSelected
                    }
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default AutoMake;



// WEBPACK FOOTER //
// ./src/components/Segment/Creation/AutoMake/AutoMake.jsx